import {
  MAX_COUNT_OF_VISIBLE_PAGINATION_BUTTONS,
  COUNT_OF_SIBLINGS_VISIBLE_PAGINATION_BUTTONS,
} from '../constants';

const getVisiblePages = (pages, currentPage) => {
  if (currentPage - 1 <= COUNT_OF_SIBLINGS_VISIBLE_PAGINATION_BUTTONS) {
    return pages.slice(1, MAX_COUNT_OF_VISIBLE_PAGINATION_BUTTONS - 1);
  }

  if (currentPage >= pages.length - COUNT_OF_SIBLINGS_VISIBLE_PAGINATION_BUTTONS) {
    return pages.slice(
      pages.length - (MAX_COUNT_OF_VISIBLE_PAGINATION_BUTTONS - 1),
      pages.length - 1
    );
  }

  return pages.slice(
    Math.max(currentPage - 1 - COUNT_OF_SIBLINGS_VISIBLE_PAGINATION_BUTTONS, 1),
    Math.min(currentPage + COUNT_OF_SIBLINGS_VISIBLE_PAGINATION_BUTTONS, pages.length - 1)
  );
};

export default getVisiblePages;
